import { ACCOUNT_MODE } from '../enums/account-mode';

export const isAccountExpert = accountMode =>
  `${accountMode}` === `${ACCOUNT_MODE.EXPERT}` ||
  `${accountMode}` === `${ACCOUNT_MODE.DEFAULT}` ||
  `${accountMode}` === '';
